// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3v5NK","title":"ClientReferral_title__uAh1q","itemText":"ClientReferral_itemText__UjeKA"};